import IndexPage from "~/pages/index";

export default IndexPage;
